/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import { ObjectUtil } from "src/utils";
import AddressDTO from "./AddressDTO";
import InterpretingServiceDTO from "./InterpretingServiceDTO";
import LanguageProficiencyDTO from "./LanguageProficiencyDTO";
import moment from "moment";


interface UserProfileDTO {
  firstName: string;
  middleName: string | null;
  lastName: string;
  discriminator: number | null;
  gender: string;
  emailAddress: string;
  phoneNumber: string | null;
  dateOfBirth: moment.Moment | null;
  currentAddress: AddressDTO | null;
  mailingAddress: AddressDTO | null;
  profileUrl: string;
  /** Proficiency is a language and level, so we need more than just an ID */
  languageProficiencies: LanguageProficiencyDTO[];
  interpretingServices: InterpretingServiceDTO[];
}
const UserProfileDTO = {
  create: (initValues?: Partial<UserProfileDTO> | null): UserProfileDTO => {
    const defaults: UserProfileDTO = {
      firstName: "",
      middleName: null,
      lastName: "",
      discriminator: null,
      gender: "",
      emailAddress: "",
      phoneNumber: null,
      dateOfBirth: null,
      currentAddress: null,
      mailingAddress: null,
      profileUrl: "",
      languageProficiencies: [],
      interpretingServices: [],
    };
    const fixedValues: Partial<UserProfileDTO> = initValues != null
      ? {
        dateOfBirth: initValues.dateOfBirth != null ? ObjectUtil.ToMoment(initValues.dateOfBirth) : null,
        currentAddress: initValues.currentAddress != null ? AddressDTO.create(initValues.currentAddress) : null,
        mailingAddress: initValues.mailingAddress != null ? AddressDTO.create(initValues.mailingAddress) : null,
        languageProficiencies: (initValues.languageProficiencies ?? []).map(LanguageProficiencyDTO.create) as LanguageProficiencyDTO[],
        interpretingServices: (initValues.interpretingServices ?? []).map(InterpretingServiceDTO.create) as InterpretingServiceDTO[],
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default UserProfileDTO;
